module.exports = __webpack_public_path__ + "img/republique-francaise.b93efc1.svg";